<template>
    <Modal :id="id" :open="show" customSizeWid="width:700px;margin: 0 auto;padding-top:10px" :FooterDefault="false" :ClassBG="true" customModalBody="min-height: calc(100vh - 73rem);" :customModalMain="'z-index:1051'">
        <template v-slot:header>
            <h6 class="modal-title">Status do Participante</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <Form ref="Form_StatusParticipante" @submit="submit_Form_StatusParticipante">
                <div class="row mt-1">
                    <div class="col">
                        <label class="form-label">Cancelado</label>
                        <select class="form-select" v-model="participante_crud.flCancelado">
                            <option value="null">Selecione</option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-3" v-if="participante_crud.flCancelado == 'Sim'">
                    <div class="col">
                        <label class="form-label">Motivo do Cancelamento</label>
                        <select class="form-select" v-model="participante_crud.idMotivoCancelamento">
                            <option value="null">Selecione</option>
                            <option :value="motivo.idMotivoCancelamento" v-for="motivo in motivos_cancelamento" :key="motivo.idMotivoCancelamento">{{ motivo.dsMotivo }}</option>
                        </select>
                    </div>
                </div>
                <div class="mt-3"></div>
            </Form>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="button" class="btn btn-red-v2" @click="submit_Form_StatusParticipante">
                    <i class="fas fa-save pe-2"></i>
                    Salvar
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import axios from "axios";
    import Modal from "@/components/App/Modal.vue";

    export default {
        name: "StatusParticipante",
        components: {
            Modal
        },

        props: {
            id: {
                type: String,
                default: 'status_participante'
            },
            show: {
                type: Boolean,
                default: false
            },
            idParticipante: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                OcorrenciaFinalizarCrud: {
                    idOcorrencia: 0,
                    dsMotivo: ''
                },
                participante_crud: { idParticipante: 0, flCancelado: null },
                motivos_cancelamento: [],
                showErrorMessage: false,
            };
        },
        methods: {
            getParticipante() {
                let $this = this;

                axios
                    .get(
                        process.env.VUE_APP_ROOT_EVENTOS_API + "/Participante/GetById?" + "idParticipante=" + $this.idParticipante,
                        { headers: $this.$api.getTokenEventos(), })
                    .then((response) => {
                        $this.participante_crud = response.data.data;
                    })
                    .catch(function (error) {
                        $this.processoCrud = {
                            participante_crud: 0, flCancelado: null
                        };
                    });
            },
            getMotivosCancelamento() {
                let $this = this;
                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/MotivoCancelamento/Get",
                    { headers: $this.$api.getTokenEventos(), })
                    .then((response) => {
                        $this.motivos_cancelamento = response.data.data;
                        $this.getParticipante();
                    });
            },
            submit_Form_StatusParticipante() {
                let $this = this;

                $this.OcorrenciaFinalizarCrud.idOcorrencia = $this.idOcorrencia;

                $this.$refs.Form_StatusParticipante.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Participante/CancelaParticipante', $this.participante_crud, { headers: $this.$api.getTokenEventos() })
                                .then(function (response) {

                                    $this.$emit('reloadAll');
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });

            },
        },
        mounted() { },
        watch: {
            show(new_value, old_value) {
                if (new_value) {
                    this.getMotivosCancelamento();
                }
            },
        },
    };

</script>

<style scoped lang="scss">
</style>